"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _isString = _interopRequireDefault(require("lodash/isString"));
var _get = _interopRequireDefault(require("lodash/get"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _styles = require("@material-ui/core/styles");
var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));
var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));
var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));
var _clsx = _interopRequireDefault(require("clsx"));
var _backdropBgDesktop = _interopRequireDefault(require("../assets/backdrop-bg-desktop.jpg"));
var _backdropBgMobile = _interopRequireDefault(require("../assets/backdrop-bg-mobile.jpg"));
var _styles2 = require("../utilities/styles");
var _button = _interopRequireDefault(require("../button"));
var _box = _interopRequireDefault(require("../box"));
var _excluded = ["children", "label", "labelledBy", "classes", "color", "title", "onClose", "BackdropProps", "DialogTitleProps", "DialogTitleComponentProps", "CloseButtonProps", "CloseButtonComponent", "DialogContentProps", "PaperProps", "disableCloseButton", "TransitionProps", "dialogHeadingLevel"],
  _excluded2 = ["root", "paperFullScreen", "scrollPaper", "paper", "container"],
  _excluded3 = ["dialogTitleTypography"];
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var MARGIN = 32;
var buildBackgropdBackground = function buildBackgropdBackground(imgUrl) {
  return "no-repeat center / cover url(".concat(imgUrl, ")");
};
var useClasses = (0, _styles.makeStyles)(function (_ref) {
  var _closeButton;
  var palette = _ref.palette,
    gutters = _ref.gutters,
    spacing = _ref.spacing,
    breakpoints = _ref.breakpoints,
    zIndex = _ref.zIndex,
    highContrast = _ref.accessibility.highContrast;
  return {
    root: {
      zIndex: "".concat(zIndex.snackbar, " !important")
    },
    paper: (0, _defineProperty2.default)({
      boxShadow: '0 10px 20px 0px rgba(0, 0, 0, 0.50)',
      padding: gutters.modal.xs
    }, breakpoints.up('md'), {
      marginTop: MARGIN,
      marginBottom: MARGIN,
      maxHeight: '100vh',
      padding: gutters.modal.md
    }),
    paperFullScreen: {
      top: 0,
      height: '100%'
    },
    container: {
      overflow: 'visible'
    },
    scrollPaper: (0, _defineProperty2.default)({}, breakpoints.down('sm'), {
      alignItems: 'flex-start'
    }),
    backdrop: (0, _defineProperty2.default)({
      opacity: '0.7 !important',
      background: (0, _get.default)(palette, 'background.backdrop.mobile', buildBackgropdBackground(_backdropBgMobile.default))
    }, breakpoints.up('md'), {
      background: (0, _get.default)(palette, 'background.backdrop.desktop', buildBackgropdBackground(_backdropBgDesktop.default))
    }),
    dialogTitle: {
      position: 'relative',
      padding: 0,
      display: 'grid',
      gridColumnGap: '10px',
      alignItems: 'start',
      gridTemplateColumns: '1fr auto',
      marginBottom: '1em'
    },
    dialogTitleTypography: (0, _defineProperty2.default)({
      flex: 1,
      fontSize: '1.52em'
    }, breakpoints.up('sm'), {
      fontSize: '2em'
    }),
    dialogContent: (0, _defineProperty2.default)({
      display: 'flex',
      flexDirection: 'column',
      overflow: 'visible',
      padding: 0
    }, breakpoints.down('sm'), {
      padding: '0 0 30px 0'
    }),
    closeButton: (_closeButton = {
      width: 'auto',
      color: 'currentColor',
      minWidth: '.5em',
      top: '-2px',
      paddingTop: '.25em'
    }, (0, _defineProperty2.default)(_closeButton, breakpoints.down('xs'), {
      fontSize: '1rem'
    }), (0, _defineProperty2.default)(_closeButton, highContrast.mediaQuery('active'), {
      padding: spacing(.5),
      backgroundColor: 'ButtonFace',
      color: 'ButtonText',
      '&:focus,&:hover': {
        backgroundColor: 'Highlight',
        color: 'HighlightText',
        fill: 'HighlightText'
      },
      '&:focus': {
        outlineOffset: '2px',
        outline: '2px solid WindowText'
      }
    }), _closeButton),
    closeButtonFocus: {
      outline: '2px solid inherit'
    }
  };
}, {
  classNamePrefix: 'TCUIDialog'
});
var Dialog = /*#__PURE__*/(0, _react.forwardRef)(function (_ref2, ref) {
  var children = _ref2.children,
    label = _ref2.label,
    labelledBy = _ref2.labelledBy,
    classes = _ref2.classes,
    color = _ref2.color,
    title = _ref2.title,
    onClose = _ref2.onClose,
    BackdropProps = _ref2.BackdropProps,
    DialogTitleProps = _ref2.DialogTitleProps,
    DialogTitleComponentProps = _ref2.DialogTitleComponentProps,
    CloseButtonProps = _ref2.CloseButtonProps,
    CloseButtonComponent = _ref2.CloseButtonComponent,
    DialogContentProps = _ref2.DialogContentProps,
    PaperProps = _ref2.PaperProps,
    disableCloseButton = _ref2.disableCloseButton,
    TransitionProps = _ref2.TransitionProps,
    dialogHeadingLevel = _ref2.dialogHeadingLevel,
    rest = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
  var _useTheme = (0, _styles.useTheme)(),
    breakpoints = _useTheme.breakpoints;
  var isMobile = (0, _useMediaQuery.default)(breakpoints.down('sm'));
  var isSmallMobile = (0, _useMediaQuery.default)(breakpoints.down('xs'));
  var _useClasses = useClasses(),
    root = _useClasses.root,
    paperFullScreen = _useClasses.paperFullScreen,
    scrollPaper = _useClasses.scrollPaper,
    paper = _useClasses.paper,
    container = _useClasses.container,
    _classes = (0, _objectWithoutProperties2.default)(_useClasses, _excluded2);
  var dialogTitleTypography = classes.dialogTitleTypography,
    restClasses = (0, _objectWithoutProperties2.default)(classes, _excluded3);
  var closeButtonSize = isSmallMobile ? 'lg' : '2x';
  return /*#__PURE__*/_react.default.createElement(_Dialog.default, (0, _extends2.default)({
    fullWidth: true,
    scroll: "body",
    maxWidth: "sm",
    "aria-label": label,
    "aria-labelledby": labelledBy,
    fullScreen: isMobile,
    role: "dialog",
    PaperComponent: _box.default,
    ref: ref,
    TransitionProps: {
      role: 'presentation'
    }
  }, rest, {
    onClose: onClose,
    PaperProps: (0, _extends2.default)({
      color: color
    }, PaperProps, {
      className: (0, _clsx.default)(paper, PaperProps.className),
      gutters: null
    }),
    classes: (0, _styles2.mergeClasses)({
      root: root,
      paperFullScreen: paperFullScreen,
      scrollPaper: scrollPaper,
      container: container
    }, restClasses),
    BackdropProps: (0, _extends2.default)({}, BackdropProps, {
      className: (0, _clsx.default)(_classes.backdrop, BackdropProps.className)
    })
  }), (!disableCloseButton || !!title) && /*#__PURE__*/_react.default.createElement(_DialogTitle.default, (0, _extends2.default)({}, DialogTitleProps, {
    className: (0, _clsx.default)(_classes.dialogTitle, DialogTitleProps.className),
    disableTypography: true
  }), (0, _isString.default)(title) ? /*#__PURE__*/_react.default.createElement(_Typography.default, (0, _extends2.default)({}, DialogTitleComponentProps, {
    id: labelledBy,
    "aria-live": "polite",
    variant: dialogHeadingLevel,
    className: (0, _clsx.default)(_classes.dialogTitleTypography, dialogTitleTypography)
  }), title) : /*#__PURE__*/_react.default.createElement("div", null, title), !disableCloseButton && /*#__PURE__*/_react.default.createElement(_button.default, (0, _extends2.default)({}, CloseButtonProps, {
    autoFocus: true
    /* eslint-disable-line jsx-a11y/no-autofocus */,

    onClick: onClose,
    classes: (0, _styles2.mergeClasses)({
      root: _classes.closeButton,
      focusVisible: _classes.closeButtonFocus
    }, CloseButtonProps.classes)
  }), !!CloseButtonComponent ? CloseButtonComponent : /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: ['tcs', 'close'],
    size: closeButtonSize
  }))), /*#__PURE__*/_react.default.createElement(_DialogContent.default, (0, _extends2.default)({}, DialogContentProps, {
    className: (0, _clsx.default)(_classes.dialogContent, DialogContentProps.className)
  }), children));
});
Dialog.propTypes = {
  children: _propTypes.default.node,
  label: _propTypes.default.string,
  labelledBy: _propTypes.default.string,
  classes: _propTypes.default.object,
  title: _propTypes.default.string,
  BackdropProps: _propTypes.default.object,
  DialogTitleProps: _propTypes.default.object,
  DialogTitleComponentProps: _propTypes.default.object,
  CloseButtonProps: _propTypes.default.object,
  CloseButtonComponent: _propTypes.default.element,
  DialogContentProps: _propTypes.default.object,
  PaperProps: _propTypes.default.object,
  disableCloseButton: _propTypes.default.bool,
  onClose: _propTypes.default.func,
  color: _propTypes.default.string,
  dialogHeadingLevel: _propTypes.default.string
};
Dialog.defaultProps = {
  children: null,
  label: null,
  labelledBy: null,
  classes: {},
  title: null,
  BackdropProps: {},
  DialogTitleProps: {},
  DialogTitleComponentProps: {},
  CloseButtonProps: {},
  DialogContentProps: {},
  PaperProps: {},
  disableCloseButton: false,
  onClose: function onClose() {
    return null;
  },
  color: null,
  dialogHeadingLevel: 'h2'
};
var _default = Dialog;
exports.default = _default;